import { connect } from "vuex-connect";
import { GoldAutochargePaypalSubmitCardInformationSecure } from "../../components";

export default connect({
  actionsToProps: {},
  mutationsToProps: {
    updateIsBusy: "common/updateIsBusy"
  }
})(
  GoldAutochargePaypalSubmitCardInformationSecure.extendOptions.name,
  GoldAutochargePaypalSubmitCardInformationSecure
);
